import { toDateOnly } from '@/utils/date'
import type { PolicyVigencyLinkPayload } from '@/Network/Types/Requests/DsPaymentPolicyRequests'
import type { PaymentPolicyLink } from '@/Network/Types/Responses/DsPaymentPolicyResponses'

/**
 * Seleciona o vinculo de vigencia mais recente de uma politica de pagamento.
 * Mais recente = maior `startDate`; empate desempatado pelo maior `id`.
 * Retorna `null` para lista vazia, `undefined` ou `null`.
 */
export const pickLatestPolicyLink = (
  links?: PaymentPolicyLink[] | null
): PaymentPolicyLink | null => {
  if (!links?.length) return null

  let latest: PaymentPolicyLink | null = null
  for (const link of links) {
    // A API ja exclui vinculos soft-deleted; checagem defensiva caso o
    // campo venha preenchido em alguma resposta.
    if (link.deletedAt != null) continue
    if (
      !latest ||
      link.startDate > latest.startDate ||
      (link.startDate === latest.startDate && link.id > latest.id)
    ) {
      latest = link
    }
  }
  return latest
}

/**
 * Monta o payload de vigencia (link) a partir das datas locais selecionadas.
 * As ancoras UTC sao construidas a partir do dia de calendario LOCAL
 * (nunca via `.toISOString()` na Date crua, o que causaria bug de D-1
 * em timezones negativos):
 * - `startDate` → `YYYY-MM-DDT00:00:00.000Z`
 * - `endDate` → `YYYY-MM-DDT23:59:59.999Z`; vigencia indeterminada ⇒ `null`.
 */
export const buildPolicyLinkPayload = (input: {
  startDate: Date
  endDate: Date | null
  indefiniteEndDate: boolean
}): PolicyVigencyLinkPayload => {
  const endDate =
    input.indefiniteEndDate || !input.endDate ? null : `${toDateOnly(input.endDate)}T23:59:59.999Z`

  return {
    startDate: `${toDateOnly(input.startDate)}T00:00:00.000Z`,
    endDate
  }
}
